module.exports = __webpack_public_path__ + "static/media/timeline-2.646ca54f.png";